function GLError(rawError, shortMessage, longMessage) {
  this.shortMessage = shortMessage || '';
  this.longMessage = longMessage || '';
  this.rawError = rawError || '';
  this.message = 'gl-shader: ' + (shortMessage || rawError || '') + (longMessage ? '\n' + longMessage : '');
  this.stack = new Error().stack;
}
GLError.prototype = new Error();
GLError.prototype.name = 'GLError';
GLError.prototype.constructor = GLError;
module.exports = GLError;